import { render, staticRenderFns } from "./ThemeColorsInput.vue?vue&type=template&id=43c1c138&lang=pug&"
import script from "./ThemeColorsInput.vue?vue&type=script&lang=ts&"
export * from "./ThemeColorsInput.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeColorsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports